import styled from "styled-components";

export const InLineContainer = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;
`

export const Link = styled('a')`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 20px;
  background-color: #2ad6ff;
  color: #121619!important;
  text-decoration: none!important;
  border-radius: 6px;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.2s ease-in-out;
  border: none;
  cursor: pointer;

  &:hover {
    box-shadow: 0px 4px 8px rgba(26, 183, 234, 0.3);
    transform: translateY(-1px);
    color: #121619;
  }

  &:active {
    transform: translateY(0);
    color: #121619;
  }

    &:visited {
      color: #121619;
    }
`;
